import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';

const CarrierPaperFreeMonitoringReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.PAPER_FREE_MONITORING_CARRIER_903_SUMMARY.id,
        label: 'SUMMARY',
      },
      {
        value: ReportDefinitions.PAPER_FREE_MONITORING_CARRIER_903_DETAILS.id,
        label: 'DETAILS',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default CarrierPaperFreeMonitoringReport;

CarrierPaperFreeMonitoringReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  totalColumns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
};
